import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import adaptedImageUrl, { BASE_URL } from '../../config';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { LOCAL_STORAGE } from "../../context/LocalStorage";
import DataTableExtensions from "react-data-table-component-extensions";
import ModalDetails from "./ModalDetails";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import fetchWrapper from "../../utils/fetch/fetchWrapper";

export default function Clients() {
  const [data, setData] = useState([]);
  const MySwal = withReactContent(Swal)
  const [showModal, setShowModal] = useState(false);
  const [idRowSelected, setIdRowSelected] = useState(null);
  const [imageSelected, setImageSelected] = useState(null);
  const [lightboxImage, setLightboxImage] = useState(false)

  let token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)
  const fetchData = (event) => {
    fetchWrapper()
      .doGet({
          url: "/clients",          
          onSuccess: async (response) => {
              setData(response.data.data)
          },
          onError: (response) => {
              alert(response.data.message);
          },
          })
          .then(() => {
          })
          .catch((error) => {
          });
  }

  useEffect(() => {
    fetchData()
  }, []);


  const handleActiveCheckboxChange = (event) => {
    var idCheck = event.target.value;
    MySwal.fire({
      title: <p>¿Está seguro de cambiarle el estado al usuario?</p>,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Confirmar',
      onOpen: () => {

      }
    }).then((result) => {
      if (result.value) {
        fetchWrapper()
          .doPost({
              url: "/active_desactive_profile",
              body:{
                  profile_id: idCheck
              },
              onSuccess: async (response) => {
                  fetchData()
                  Swal.fire(
                    'Confirmado!',
                    'Se ha cambiado el estado.',
                    'success'
                  )
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
      }
    });
  }

  const setImageLightbox = (image_url) => {
    setImageSelected(image_url)
    setLightboxImage(true)
  }
  const CustomImage = ({ row }) => (
    <div onClick={() => setImageLightbox(adaptedImageUrl(row.avatar_url))}>
      <img height="50px" width="50px" className="w-full  align-middle border-none shadow-lg"
        src={adaptedImageUrl(row.avatar_url) ?? null} />
    </div>
  );

  const editModal = (id) => {
    console.log(id)
    setIdRowSelected(id)
    setShowModal(true)
  }
  const columns = [
    {
      name: 'Avatar',
      grow: 0,
      cell: row => <CustomImage row={row} />,
    },
    {
      name: "Email",
      selector: "email",
      grow: 3,
      sortable: true,
    },
    {
      name: "Nombre",
      selector: "first_name",
      sortable: true,
    },
    {
      name: "Apellido",
      selector: "last_name",
      sortable: true,
    },
    {
      name: "Genero",
      selector: "gender",
      sortable: true,
    },
    {
      name: "Código",
      selector: "invitation_code",
      sortable: true,
    },
    {
      name: "Fecha",
      selector: "date",
      grow: 3,
      sortable: true,
    },
    {
      name: "Direccion",
      selector: "address",
      grow: 3,
    },
    {
      name: "Departamento",
      selector: "department",
      grow: 3,
    },
    {
      name: 'Activar/Desactivar Usuario',
      cell: row => <label className="form-check form-switch"> <input className="form-check-input" value={row.id} checked={row.active == 1 ? true : false} type="checkbox" onChange={handleActiveCheckboxChange} /><span className="slider round"> </span></label>,
    },
    {
      name: 'Ver detalle',
      cell: row => <a onClick={() => editModal(row.id)}><i class="fas fa-eye"></i></a>,
    },
  ];

  const tableData = {
    columns,
    data
  };
  return (
    <>
      <ModalDetails
        showModal={showModal}
        setShowModal={setShowModal}
        id={idRowSelected}
        setId={setIdRowSelected}
        fetchData={fetchData}
      />
      {lightboxImage && (
        <Lightbox
          mainSrc={imageSelected}
          onCloseRequest={() => setLightboxImage(false)}
        />
      )}
      <div className="row">
        <h1>Administración de clientes</h1>
      </div>

      <DataTableExtensions {...tableData}>

        <DataTable
          columns={columns}
          data={data}
          pagination
          paginationPerPage={10}
        />
      </DataTableExtensions>

    </>
  );
}
